<input type="color" disabled value="{{ colorString }}" class="form-control form-control-lg"/>
